import React from "react";

/**
 * Opportunities: a magnifying glass with a sparkle in the lens - "find
 * something worth having". Distinct from Leads (target + arrow) and not tied
 * to maintenance: opportunities will come from outside our own projects too
 * (Jack, 2026-10-07).
 *
 * Same props / sizing contract as LeadsIcon (18 x 18 viewBox, colour from
 * `fill`, drawn as strokes). NO <path> elements and fill="none" on every
 * outline shape: the NavLink active/hover CSS forces `svg` and `path` to
 * fill white !important, which floods outline icons.
 */
export default function OpportunitiesIcon(props?: any) {
  const svgStyles: any = {
    width: props?.width ? props.width : null,
    height: props?.height ? props.height : null,
    fill: props?.fill ? props.fill : null,
    margin: props?.margin ? props.margin : null,
  };

  const filteredStyles = Object.keys(svgStyles)
    .filter((key) => svgStyles[key] !== null && svgStyles[key] !== undefined)
    .reduce((acc: any, key) => {
      acc[key] = svgStyles[key];
      return acc;
    }, {});

  const color = filteredStyles.fill ?? "currentColor";

  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      style={{ ...filteredStyles, fill: "none" }}
      className={props?.className}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Lens and handle */}
      <circle cx="7.4" cy="7.4" r="5.4" fill="none" stroke={color} strokeWidth={1.2} />
      <line x1="11.4" y1="11.4" x2="16.4" y2="16.4" stroke={color} strokeWidth={1.7} strokeLinecap="round" />
      {/* Four-point sparkle inside the lens */}
      <line x1="7.4" y1="4.4" x2="7.4" y2="10.4" stroke={color} strokeWidth={1.1} strokeLinecap="round" />
      <line x1="4.4" y1="7.4" x2="10.4" y2="7.4" stroke={color} strokeWidth={1.1} strokeLinecap="round" />
      <line x1="5.9" y1="5.9" x2="8.9" y2="8.9" stroke={color} strokeWidth={0.8} strokeLinecap="round" />
      <line x1="8.9" y1="5.9" x2="5.9" y2="8.9" stroke={color} strokeWidth={0.8} strokeLinecap="round" />
    </svg>
  );
}
